var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmtyEinsten = function SvgEmtyEinsten(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 94,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-32.9%",
    y: "-16%",
    width: "165.9%",
    height: "158.9%",
    filterUnits: "objectBoundingBox",
    id: "EmtyEinsten_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.191597465 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-5.3%",
    y: "-3.7%",
    width: "110.6%",
    height: "106.6%",
    filterUnits: "objectBoundingBox",
    id: "EmtyEinsten_svg__b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m8.345 0-7.7 33.506a1.8 1.8 0 0 0 2.16 2.157l16.881-3.912a3.3 3.3 0 0 0 2.488-2.555l4.348-21.284L8.345 0Z",
    id: "EmtyEinsten_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.535 0 .7 35.975a1.8 1.8 0 0 0 2.154 2.183l16.833-3.901a3.3 3.3 0 0 0 2.488-2.555l4.348-21.284L9.535 0Z",
    id: "EmtyEinsten_svg__e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "39.582%",
    x2: "73.145%",
    y2: "85.51%",
    id: "EmtyEinsten_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAC8C8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B3B3",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmtyEinsten_svg__a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CCC",
    fillRule: "nonzero",
    cx: 40.84,
    cy: 40.408,
    rx: 37.65,
    ry: 37.251
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#888787",
    strokeWidth: 1.5,
    cx: 41,
    cy: 40.566,
    rx: 36.421,
    ry: 36.028
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#D5D5D5",
    strokeWidth: 3.6,
    cx: 41,
    cy: 40.566,
    rx: 39.2,
    ry: 38.766
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmtyEinsten_svg__b)",
    transform: "translate(12.444 12.312)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.526 45.375)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "EmtyEinsten_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EmtyEinsten_svg__c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#B6B4B4",
    fillRule: "nonzero",
    xlinkHref: "#EmtyEinsten_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    fillRule: "nonzero",
    mask: "url(#EmtyEinsten_svg__d)",
    d: "m9.535 35.022 8.25-31.383L28.77 4.96l-5.221 28.03z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 56.445 42.869)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "EmtyEinsten_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EmtyEinsten_svg__e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#B6B4B4",
    fillRule: "nonzero",
    xlinkHref: "#EmtyEinsten_svg__e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    fillRule: "nonzero",
    mask: "url(#EmtyEinsten_svg__f)",
    d: "m9.535 37.528 8.25-31.383 10.985 1.32-5.221 28.03z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.58 46.029C6.202 41.86 2.388 43.613.5 39.075c-1.888-4.538 2.16-5.384 2.387-11.535.227-6.15-3.857-5.477-1.981-10.9 1.875-5.424 5.544-2.253 9.673-6.36 4.13-4.107 1.311-6.945 6.277-9.443C21.822-1.66 22.603 3.1 28.194 3.1c5.591 0 6.535-4.497 11.187-2.657 4.652 1.84 2.864 5.864 6.963 9.838 4.1 3.974 7.78 1.6 9.743 6.36 1.964 4.76-2.118 6.96-2.118 12.128 0 5.169 3.836 6.185 2.118 10.307-1.717 4.121-5.104 2.035-8.934 6.05-3.83 4.016-1.305 7.488-5.988 9.596-4.683 2.108-6.599-1.697-12.137-1.438-5.538.26-6.125 4.424-10.964 2.52-4.84-1.902-3.108-5.606-7.485-9.774Z",
    fill: "url(#EmtyEinsten_svg__g)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#888787",
    fillRule: "nonzero",
    cx: 28.397,
    cy: 28.096,
    rx: 19.144,
    ry: 18.941
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.628 47.445s-.331.588.459 1.726c.534.77.675 1.794.71 2.375a.483.483 0 0 0 .483.454h.323a.484.484 0 0 0 .467-.356c.16-.578.414-1.774.202-2.95v-1.677l-2.644.428Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.38 45.735s-.272 3.221 2.186 4.134c0 0 .862.326 1.547-.327 0 0 3.816 1.053 3.675-2.88l-4.308-3.347h-3.019s-.355.906-.08 2.42Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.48 43.315h-2.422v1.197s1.546-.29 2.976 1.65c1.205 1.635 2.537 1.81 3.658 1.663.083-.382.115-.772.096-1.162l-4.307-3.348Z",
    fill: "#888787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.305 43.604.025-.289h-.869s-.355.906-.08 2.42c0 0-.102 1.204.38 2.348.337-.265.57-.64.66-1.058a2.43 2.43 0 0 0-.124-1.337 1.85 1.85 0 0 1-.102-.783l.11-1.3Z",
    fill: "#888787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.516 43.562.054.914-.031.374c-.008.09-.078.786.138 1.061.19.532.32 1.437-.731 1.9-1.545.678-2.107-1.242-2.107-1.242s-.28-1.077-.772-1.475c0 0 1.713-1.835 3.45-1.532Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.067 45.094c.244.198.436.564.568.882.272-.138.526-.306.76-.502.714-.613 1.722-.896 2.175-.998l.078-.927c-1.736-.303-3.581 1.545-3.581 1.545Z",
    fill: "#888787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.173 42.5s1.092 4.404 4.65 3.03a10.842 10.842 0 0 0 1.806-1.012c1.183-.829 2.7-1.064 4.057-.568l.134.05a4.23 4.23 0 0 1 1.499 1.049c.688.735 3.005 2.952 4.697 1.467 0 0 .916-.845.67-2.15 0 0 2.22-3.312-.6-6.13 0 0 1.093-3.243-2.889-4.97 0 0-.603-1.943-3.002-2.311l-1.85.021s-1.526-1.938-4.909-.352c0 0-3.136-1.48-5.532 1.444 0 0-3.735 1.022-3.453 4.405 0 0-1.34 2.08.599 3.7 0 0 .211 2.502 4.123 2.326Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.096 31.302c-.836.242-1.09 1.048-1.164 1.434-.434.197-.824.48-1.145.833-.419-.435-.247-.978-.222-1.048a.33.33 0 0 0-.62-.227c-.142.387-.203 1.207.44 1.802a4.441 4.441 0 0 0-.543 1.257 5.076 5.076 0 0 0-2.375-.087 4.297 4.297 0 0 0-1.402.575 4.524 4.524 0 0 0-1.054.932 2.876 2.876 0 0 0-.881-.692c.129-.227.327-.406.565-.513a.33.33 0 1 0-.271-.6 1.876 1.876 0 0 0-.939.927 7.697 7.697 0 0 0-1.04-.063c-.014.214-.012.428.006.641.333.018.755.043 1.013.082.445.067.88.386 1.292.95.05.072.617.874 1.254 1.281a.33.33 0 0 0 .354-.555c-.377-.241-.746-.68-.936-.926a3.743 3.743 0 0 1 1.487-1.177c-.071.389-.008.877.365 1.42a.33.33 0 1 0 .543-.374c-.47-.683-.224-1.132-.1-1.29.625-.113 1.378-.087 2.27.199a.33.33 0 0 0 .427-.273c.092-.56.315-1.09.65-1.55a.33.33 0 0 0 .043-.052l.005-.01c.32-.414.747-.734 1.235-.925a.331.331 0 0 0 .207-.282c0-.01.075-.87.72-1.057a.33.33 0 1 0-.184-.632Z",
    fill: "#888787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.904 32.068h-.001c.113.028.5.163.618.72.087.437-.036.889-.332 1.222-.063.072-.13.139-.202.2a.335.335 0 0 0 .434.51c.098-.082.19-.173.273-.27.4-.455.585-1.06.508-1.662a1.444 1.444 0 0 0 1.1-.64.335.335 0 1 0-.551-.381.834.834 0 0 1-.77.355 1.477 1.477 0 0 0-.595-.576 5.85 5.85 0 0 0-.482.522Zm8.944 5.863a2.78 2.78 0 0 1-1.77.14c-1.029-.242-2.072-.184-2.603-.128a.33.33 0 0 0 .07.655c.488-.051 1.448-.105 2.38.115.278.066.561.1.846.1.462.002.92-.093 1.343-.279a6.252 6.252 0 0 0 1.918-1.288c.44-.44.785-.964 1.016-1.542a.33.33 0 0 0-.613-.242c-.093.236-.21.46-.348.673a1.267 1.267 0 0 0-.312-.508.332.332 0 0 0-.552.26.326.326 0 0 0 .108.227c.011.01.252.253.153.747a5.636 5.636 0 0 1-1.636 1.07Z",
    fill: "#888787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.405 33.066c-.551.233-2.51 1.25-2.431 3.908a.33.33 0 0 0 .317.32h.022a.33.33 0 0 0 .32-.34c-.076-2.57 2.026-3.287 2.115-3.316a.363.363 0 0 0 .2-.177c.638-1.13 1.133-1.547 1.638-1.884.62-.412 1.082-.498 1.609-.622a6.12 6.12 0 0 0-1.85.021c-.478.23-1.32.803-1.94 2.09Z",
    fill: "#888787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.37 33.201a5.033 5.033 0 0 0-1.695-.049c-1.308.2-3.495.959-3.445 3.795a.33.33 0 0 0 .329.324h.006a.33.33 0 0 0 .323-.335c-.038-2.219 1.549-2.928 2.886-3.132.49-.066.988-.051 1.473.045 1.577.285 2.474-.02 2.781-.16a7.245 7.245 0 0 0-.83-.422 6.145 6.145 0 0 1-1.828-.066Zm4.842 3.721a3.817 3.817 0 0 0-.11-.657c-.369.001-1.176-.05-1.657-.49-.91-.833-1.848-.515-1.887-.5a.326.326 0 0 0-.207.424c.072.173.269.259.445.194.024-.007.581-.179 1.165.355.652.597 1.647.676 2.127.676.046 0 .088 0 .124-.002Zm-14.553.07c-.032.015-.737.379-.895 1.572a3.292 3.292 0 0 0-1.973 1.955 2.503 2.503 0 0 1-1.285-.428.33.33 0 1 0-.373.543c.436.298.941.48 1.468.53-.094.44-.127.89-.097 1.338.21.008.432.007.669-.003a3.86 3.86 0 0 1 .14-1.506.325.325 0 0 0 .026-.083c.235-.701.746-1.444 1.83-1.79.002 0 .002-.001.003-.002a.325.325 0 0 0 .043-.018l.017-.008a.315.315 0 0 0 .032-.022l.021-.015a.341.341 0 0 0 .026-.027l.018-.019a.335.335 0 0 0 .024-.038l.01-.015a.336.336 0 0 0 .013-.033c.003-.009.008-.017.01-.027l.005-.024a.326.326 0 0 0 .007-.043c.067-.958.53-1.233.559-1.25a.33.33 0 0 0-.298-.588Zm-5.12 1.926a.33.33 0 0 0-.61.245c.044.106.096.21.154.308a.33.33 0 0 0 .57-.33 2.045 2.045 0 0 1-.114-.223Zm6.445 2.055c.488-.116 1.06-.099 1.701.051.507.123 1.03.157 1.549.1a4.567 4.567 0 0 0 1.764-.559 3.869 3.869 0 0 1 1.445-.486c.556-.073 1.287-.362 1.654-1.307.044-.042.217-.175.587-.111a.33.33 0 1 0 .112-.65 1.707 1.707 0 0 0-.37-.024c.29-.587.52-.788.52-.788a.33.33 0 1 0-.412-.515c-.055.044-.552.469-1.034 1.806-.197.547-.582.862-1.143.936a4.526 4.526 0 0 0-1.689.569 3.722 3.722 0 0 1-1.17.421 1.39 1.39 0 0 0 .202-.685.33.33 0 0 0-.66 0c0 .025-.01.601-.728.735a4.324 4.324 0 0 1-.476-.084c-.742-.173-1.415-.19-2.003-.05-.402.093-.77.293-1.069.578a.764.764 0 0 1-.331-.507.33.33 0 0 0-.654.085c.004.03.083.609.578.947a2.255 2.255 0 0 0-.218.533c-.29 1.097.45 1.85.882 2.095.157.09.357.035.447-.122a.33.33 0 0 0-.12-.45c-.033-.019-.803-.48-.572-1.355a1.648 1.648 0 0 1 1.208-1.163Z",
    fill: "#888787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.87 45.59c.171-2.129-1.092-2.905-1.287-3.011-.205-.135-2.004-1.254-4.04-.392-1.76.745-2.796.066-2.845.033a.33.33 0 0 0-.378.54c.054.038 1.36.931 3.48.033 1.78-.753 3.413.33 3.428.34a.387.387 0 0 0 .037.023c.04.02.856.461.953 1.789.034.034.068.068.1.103.177.188.361.369.552.542Zm3.723-1.979a4.612 4.612 0 0 0-.687-.15 6.313 6.313 0 0 1-.32-.06 2.22 2.22 0 0 1-1.394-.978c-.983-1.527-2.427-1.16-2.488-1.144a.33.33 0 0 0 .169.637c.042-.01 1.048-.25 1.765.864a2.875 2.875 0 0 0 1.807 1.266c.115.025.236.045.353.064.2.028.396.07.589.127.454.14.82.479.993.921.06.136.137.263.23.378.125-.377.15-.78.075-1.17a2.154 2.154 0 0 0-1.092-.755Zm.599-3.559c.033-.93-.219-1.53-.48-1.898.129.006.255.033.375.081a3.13 3.13 0 0 0 .121-.659 1.886 1.886 0 0 0-1.182.024l-.028.01-.047.014a.827.827 0 0 1-.622-.034.975.975 0 0 1-.342-.298.33.33 0 0 0-.53.391c.15.208.347.378.576.495.289.141.616.183.932.12.19.159.608.636.568 1.73a.33.33 0 0 0 .659.023v.001Z",
    fill: "#888787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.321 40.217c-.166.328-.365.64-.593.928-.41.525-1.366.506-1.466.496a1.53 1.53 0 0 1-.505-.135c-.639-.302-.494-.803-.46-.897a.317.317 0 0 0 .012-.041c.223-.903-.163-1.235-.242-1.292a.33.33 0 0 0-.407.518c.016.02.115.175.014.598-.147.407-.16 1.255.802 1.71a2.186 2.186 0 0 0 .72.195c.679.068 1.57-.055 2.063-.711.085-.114.168-.23.248-.348a4.343 4.343 0 0 0-.186-1.021Zm-2.412 4.822a.33.33 0 0 0-.359.552c.033.022.746.504.74 1.34.23-.073.446-.188.634-.34-.154-.983-.973-1.526-1.015-1.552ZM47.886 49.603c-1.954-.18-2.488-1.913-2.488-1.913a2.34 2.34 0 0 0-.614-.877.124.124 0 0 0-.185.158c.168.273.3.565.392.871.207.658.537 1.27 1.122 1.7.58.143 1.184.164 1.773.06Zm-5.171-3.579a2.677 2.677 0 0 0-.038-.114 1.215 1.215 0 0 1-.133-.619c-.236-.11-.5-.14-.755-.09a.108.108 0 0 0-.007.212c.374.084.706.301.933.611Z",
    fill: "#888787"
  })))));
};
export default SvgEmtyEinsten;